import ACTIONS from './types'
import cuid from 'cuid'
import keyBy from 'lodash/keyBy'
import times from 'lodash/times'
import isNull from 'lodash/isNull'
import slice from 'lodash/slice'
import concat from 'lodash/concat'
import { refElements } from 'components/Canvas/renderer/utils/elementUtils'
import { initialColumn } from 'helpers/initialState'
import { renewElementIdInTemplate, injectProductCardConfig } from 'helpers/elementHelpers'
import { selectElementsConfig } from 'store/preferences/selectors'

const generateColumn = (amount, number) => (
  times(
    number ? number : amount,
    () => ({
      ...initialColumn,
      defaultContent: {
        gutter: 0,
      },
      defaultSettings: {
        computer: 12/amount,
        tablet: 12/amount,
        mobile: 12/amount,
        only: 'mobile tablet computer large screen widescreen',
      },
      id: cuid(),
    })
  )
)

export const addColumn = ({ amount, element }) => {
  const newColumns = generateColumn(amount, amount - element.elements.length)
  const columns = concat(element.elements, newColumns)
  return {
    element: {
      id: cuid(),
      ...element,
      elements: columns.map(({ id }) => id)
    },
    columnById: keyBy(columns, 'id'),
    newElements: newColumns,
  }
}

export const removeColumn = ({ amount, element }) => {
  return {
    element: {
      id: cuid(),
      ...element,
      elements: slice(element.elements, 0, amount).map(({ id }) => id),
    },
  }
}

export const createColumns = ({ amount, element ,parentId }) => ({
  type: ACTIONS.ADD_COLUMN,
  ...addColumn({ amount, element }),
  parentId,
})

export const removeColumns = ({ amount, element ,parentId }) => ({
  type: ACTIONS.REMOVE_COLUMN,
  ...removeColumn({ amount, element }),
  parentId,
})

export const addTemplateToRoot = (template, addToIndex) => ({
  type: ACTIONS.ADD_TEMPLATE_TO_ROOT,
  addToIndex,
  ...renewElementIdInTemplate(template),
})

export const addTemplateToElement = ({ parentId, template, addToIndex }) => ({
  type: ACTIONS.ADD_TEMPLATE_TO_ELEMENT,
  parentId,
  addToIndex,
  ...renewElementIdInTemplate(template)
})

export const initializePaint = () => ({
  type: ACTIONS.INITIALIZE_PAINT
})

export const injectPaint = ({ details = [], elementById = {} }) => ({
  type: ACTIONS.INJECT_PAINT,
  details,
  elementById,
})

export const overElement = (elementId) => ({
  type: ACTIONS.OVER_ELEMENT,
  elementId,
})

const createColumnsChildren = (element) => {
  const columns = generateColumn(2)
  return {
    element: {
      id: cuid(),
      ...element,
      elements: columns.map(({ id }) => id)
    },
    columnById: keyBy(columns, 'id')
  }
}

export const clearIsElementChange = () => ({
  type: ACTIONS.CLEAR_IS_ELEMENT_CHANGE,
})

const createElementByRef = (element, elementConfig) => {
  switch (element.refElement) {
    case refElements.COLUMNS:
      return createColumnsChildren(element)
    case refElements.PRODUCT_SLIDER:
      return {
        element: {
          id: cuid(),
          ...element,
          defaultSettings: {
            ...element.defaultSettings,
            product: injectProductCardConfig(elementConfig.productCard),
          },
        },
      }
    case refElements.PRODUCT_CARD:
      return {
        element: {
          id: cuid(),
          ...element,
          defaultSettings: injectProductCardConfig(elementConfig.productCard),
        },
      }
    default:
      return {
        element: { id: cuid(), ...element }
      }
  }
}

export const createRootElement = (element, addToIndex) => (dispatch, getState) => {
  const elementConfig = selectElementsConfig(getState())
  return dispatch({
    type: ACTIONS.CREATE_ROOT_ELEMENT,
    ...createElementByRef(element, elementConfig),
    addToIndex,
  })
}

export const createElement = ({
  element,
  parentId,
  addToIndex,
}) => (dispatch, getState) => {
  const elementConfig = selectElementsConfig(getState())
  return dispatch({
    type: ACTIONS.CREATE_ELEMENT,
    ...createElementByRef(element, elementConfig),
    parentId,
    addToIndex,
  })
}

export const selectElement = (elementId) => {
  return ({
    type: ACTIONS.SELECT_ELEMENT,
    elementId
  })
}

export const deleteElement = (parentId, elementId) => ({
  type: ACTIONS.DELETE_ELEMENT,
  parentId,
  elementId,
})

export const deleteRootElement = (elementId) => ({
  type: ACTIONS.DELETE_ROOT_ELEMENT,
  elementId,
})

export const updateElement = (element) => ({
  type: ACTIONS.UPDATE_ELEMENT,
  element,
})

export const openSelector = (selectorId) => ({
  type: ACTIONS.OPEN_ELEMENTS_SELECTOR,
  selectorId
})

export const closeSelector = () => ({
  type: ACTIONS.CLOSE_ELEMENTS_SELECTORS,
})

export const setStateChanged = () => ({
  type: ACTIONS.SET_STATE_CHANGED,
})

export const clearStateChanged = () => ({
  type: ACTIONS.CLEAR_STATE_CHANGED,
})

export const switchDown = (parentId, elementId) => ({
  type: ACTIONS.SWITCH_DOWN,
  parentId,
  elementId,
})

export const switchUp = (parentId, elementId) => ({
  type: ACTIONS.SWITCH_UP,
  parentId,
  elementId,
})

export const switchRootUp = (elementId) => ({
  type: ACTIONS.SWITCH_ROOT_UP,
  elementId,
})

export const switchRootDown = (elementId) => ({
  type: ACTIONS.SWITCH_ROOT_DOWN,
  elementId,
})




// WEBPACK FOOTER //
// ./src/store/canvas/actions.js